import React, { useLayoutEffect } from 'react';
import { useNavigation } from '../contexts/NavigationContext';
import { SPACING, TYPOGRAPHY, COLORS, BORDER_RADIUS, SHADOWS } from '../styles/UISystem';
import { CaretLeft } from '@phosphor-icons/react/dist/ssr/CaretLeft';
import { IconCircleButton } from '../components/UISystem/Icons/IconCircleButton';
import { InstagramLogo } from '@phosphor-icons/react/dist/ssr/InstagramLogo';

/**
 * TomDetailPage - Easter egg detail page for Tom Anderson (MySpace founder)
 *
 * Static page showing Tom's info. Everyone's first friend.
 * Matches AnonConnectionDetailPage styling but with hardcoded data.
 */
const TomDetailPage = () => {
  const { navigateTo } = useNavigation();

  // Reset scroll position when component mounts
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    navigateTo('anon-connections-list');
  };

  // Static Tom data
  const tomData = {
    name: 'Tom',
    photoUrl: '/images/profiles/tom-myspace-orig.jpeg',
    instagram: 'myspacetom',
    role: 'Your first friend',
    organization: 'MySpace',
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: COLORS.WHITE,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 16px',
      }}
    >
      {/* Grey card container - matches AnonConnectionDetailPage */}
      <div
        style={{
          position: 'relative',
          backgroundColor: '#F3F3F2',
          borderRadius: '32px',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Scrollable content area */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
          }}
        >
          {/* Back button - absolute top left inside card */}
          <div
            onClick={handleBack}
            style={{
              position: 'absolute',
              top: '16px',
              left: '16px',
              display: 'flex',
              alignItems: 'center',
              padding: '8px 10px',
              borderRadius: BORDER_RADIUS.PILL,
              backgroundColor: '#FFFFFF',
              boxShadow: SHADOWS.TIER1,
              cursor: 'pointer',
              zIndex: 10,
            }}
          >
            <CaretLeft size={26} color="#555555" weight="bold" />
          </div>

          {/* Profile Content Block */}
          <div
            style={{
              paddingTop: '16px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '12px',
              paddingLeft: '24px',
              paddingRight: '24px',
            }}
          >
            {/* Profile Photo */}
            <div
              style={{
                width: '90px',
                height: '90px',
                borderRadius: '50%',
                backgroundImage: `url(${tomData.photoUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />

            {/* Name */}
            <div
              style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#000000',
                letterSpacing: '-0.3px',
                textAlign: 'center',
              }}
            >
              {tomData.name}
            </div>

            {/* Contact icons row - Instagram only */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '12px',
              }}
            >
              <IconCircleButton
                icon={InstagramLogo}
                size={24}
                buttonSize={40}
                href={`https://instagram.com/${tomData.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
              />
            </div>
          </div>

          {/* Main content area */}
          <div
            style={{
              flex: 1,
              padding: `${SPACING.LG} 24px`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {/* Date/Location pill - static "Somewhere online" / "Ages ago" */}
            <div
              style={{
                width: '100%',
                maxWidth: '340px',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  ...TYPOGRAPHY.BODY_REGULAR,
                  width: '100%',
                  color: '#999999',
                  textAlign: 'center',
                  backgroundColor: '#F8F8FA',
                  borderRadius: BORDER_RADIUS.PILL,
                  padding: '16px',
                  boxSizing: 'border-box',
                }}
              >
                <div>Ages ago</div>
                <div style={{ marginTop: '8px' }}>Internets</div>
              </div>
            </div>

            {/* Bio card - WHITE background */}
            <div
              style={{
                width: '100%',
                maxWidth: '340px',
                marginBottom: '20px',
                backgroundColor: '#FFFFFF',
                borderRadius: '24px',
                padding: '20px',
              }}
            >
              {/* Role and Organization - centered, separate lines */}
              <div>
                <div
                  style={{
                    ...TYPOGRAPHY.BODY_REGULAR,
                    color: '#000000',
                    textAlign: 'center',
                    marginBottom: '4px',
                  }}
                >
                  {tomData.role}
                </div>
                <div
                  style={{
                    ...TYPOGRAPHY.BODY_REGULAR,
                    color: '#999999',
                    textAlign: 'center',
                  }}
                >
                  {tomData.organization}
                </div>
              </div>
            </div>

            {/* Bottom padding */}
            <div style={{ height: '20px', flexShrink: 0 }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TomDetailPage;
